import React, { Component } from 'react'

export default class NotificationItem extends Component {

    constructor(props){
        super(props);
        this.state = {};
    }

    componentWillReceiveProps(nextProps){

    }

    render() {
        return (
            <div style={{display: 'flex', flexDirection: 'column', marginBottom: 5}}>
                <span className="dotted-separator"/>
                <div style={{fontSize: 14, color: 'black', textAlign: 'center', fontWeight: 'bold'}}>{this.props.nameWithLogin}</div>
                <div>{this.props.message}</div>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/components/notifictions/NotificationItem.js